<div class="main-container">
  <div class="inner-container overflow-y px-3 pb-3 text-break">
    <!-- <app-title-with-languages [title]="'404_TITLE'"></app-title-with-languages> -->
    <div class="dm-container d-flex flex-column align-items-center page-404">
      <div class="page-404-title">{{ "404_TITLE" | translate }}</div>
      <div class="page-404-body">{{ "404_BODY" | translate }}</div>
    </div>
  </div>
</div>
